import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DesignCorrespondenceHandoverContent from '../content/designCorrespondenceHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class DesignCorrespondenceHandover extends React.Component {
	static getTitle(report) {
		return `Design Correspondence ${report.drrNumber}`;
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<DesignCorrespondenceHandoverContent report={report} />
		);
	}
}

DesignCorrespondenceHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	DesignCorrespondenceHandover, {
		title: 'Design Correspondence',
		className: 'design-correspondence-handover'
	})
);
